/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../../Fixes';
import Builder from '../../../../../Builder';
import '../../models/application_flow_update';
import '../../models/application_flow';
import '../../../../connect/v2/resources/error';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "sfs": {
        "nested": {
          "external": {
            "nested": {
              "service": {
                "nested": {
                  "SubmitApplicationFlowRequest": {
                    "fields": {
                      "idempotencyKey": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "applicationFlowId": {
                        "type": "string",
                        "id": 2,
                        "rule": "optional"
                      },
                      "applicationFlow": {
                        "type": ".squareup.sfs.external.models.ApplicationFlowUpdate",
                        "id": 3,
                        "rule": "optional"
                      },
                      "taxTinType": {
                        "type": ".squareup.sfs.external.models.ApplicationFlow.TaxTinType",
                        "id": 5,
                        "rule": "optional"
                      }
                    }
                  },
                  "SubmitApplicationFlowResponse": {
                    "fields": {
                      "applicationFlow": {
                        "type": ".squareup.sfs.external.models.ApplicationFlow",
                        "id": 1,
                        "rule": "optional"
                      },
                      "errors": {
                        "type": ".squareup.connect.v2.resources.Error",
                        "id": 2,
                        "rule": "repeated"
                      },
                      "sspRequestToken": {
                        "type": "string",
                        "id": 3,
                        "rule": "optional"
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.sfs?.nested?.external?.nested?.service?.nested?.SubmitApplicationFlowRequest && !$root.nested?.squareup?.nested?.sfs?.nested?.external?.nested?.service?.nested?.SubmitApplicationFlowResponse) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE SubmitApplicationFlowRequest @ squareup/sfs/external/services/application_flow/submit_application_flow.proto at 10:1
 */
export const SubmitApplicationFlowRequest = $root.lookupType('squareup.sfs.external.service.SubmitApplicationFlowRequest');
fixType(SubmitApplicationFlowRequest, {
  idempotencyKey: {
    required: true
  },
  applicationFlowId: {
    required: true
  },
  taxTinType: {
    required: true
  }
});
Builder.createAndAttachToType(SubmitApplicationFlowRequest);
/**
 * SOURCE SubmitApplicationFlowResponse @ squareup/sfs/external/services/application_flow/submit_application_flow.proto at 37:1
 */
export const SubmitApplicationFlowResponse = $root.lookupType('squareup.sfs.external.service.SubmitApplicationFlowResponse');
fixType(SubmitApplicationFlowResponse);
Builder.createAndAttachToType(SubmitApplicationFlowResponse);